module.exports = __webpack_public_path__ + "static/media/iconclose.6d2c6e0f.svg";